import type { NicePayPaymentCallback200Data } from './nicePayPaymentCallback200Data';

export type NicePayPaymentCallback200 = {
  /** 응답 데이터 */
  data?: NicePayPaymentCallback200Data;
  /** 응답 메시지 */
  message: string;
  /** 성공 여부 */
  success: boolean;
};
